import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { ToastProvider } from "./components/ux/Toast";
import { ConfirmProvider } from "./components/ConfirmModal";
import "./styles/index.css";
import { AuthProvider, PlatformProvider } from "./lib/platform";
import { TrackingInitializer } from "./lib/tracking";
import { PostHogProvider } from "posthog-js/react";
import { forceParameterFeatureFlags } from "./lib/features";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const postHogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-11-30",
  loaded: forceParameterFeatureFlags,
} as const;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={postHogOptions}
    >
      <PlatformProvider>
        <TrackingInitializer>
          <QueryClientProvider client={queryClient}>
            <ToastProvider>
              <ConfirmProvider>
                <App />
              </ConfirmProvider>
            </ToastProvider>
          </QueryClientProvider>
        </TrackingInitializer>
      </PlatformProvider>
    </PostHogProvider>
  </AuthProvider>
);
